import React from 'react';
import LazyLoad from 'react-lazyload';
import MobileGridItem from './MobileGridItem';
import LinkWrapper from './../LinkWrapper';

const MobileGrid = (props) => {
  const gridItems = props.data.map((item, i) =>
    <li className={(item.video) ? 'home-grid-item-wrapper-mobile video-thumb-mobile' : 'home-grid-item-wrapper-mobile'} key={'hp-grid-mobile-' + item.image.id + i}>
      <LazyLoad>
        <MobileGridItem itemData={item}/>
      </LazyLoad>
    </li>
  );
  return (
    <ul id='image-grid-mobile'>
      {gridItems}
    </ul>
  );
};

export default MobileGrid;



// WEBPACK FOOTER //
// ./src/pages/home/mobile-grid/MobileGrid.js